import React, { useState } from 'react';

function CreateStory() {
	return (
		<div className="create-story"></div>
	);
}

export default CreateStory;
